import { ReactNode } from "react";
import "./LeafCheckBox.scss";
import { IconCheckBox } from "../../icons/IconCheckBox/IconCheckBox";

type Props = {
  id: string; // string key for identifying the list item
  label: string | ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange: Function;
  customClass?: string; // to customize styles if needed
  theme?: "black" | "blue";
};

const LeafCheckBox = (props: Props) => {
  const { id, label, checked, disabled = false, onChange, customClass = "", theme = "black" } = props;

  const labelClass = `leaf-checkbox ${customClass} leaf-checkbox--${theme}`;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.stopPropagation();
      e.preventDefault();
      onChange(e);
    }
  };

  return (
    <label className={labelClass} key={id} id={id} htmlFor={"input_" + id}>
      <input
        key={"input_" + id}
        id={"input_" + id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e)}
        data-testid={id}
        className="leaf-checkbox__input"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        aria-label={typeof label === "string" ? label : id}
      />

      <span className="leaf-checkbox__icon-wrapper">
        {checked ? <IconCheckBox color={theme} id={id} /> : <span className="leaf-checkbox__empty-box" />}
      </span>

      <span className={`leaf-checkbox__label${disabled ? "--disabled" : ""}`}>{label}</span>
    </label>
  );
};

export default LeafCheckBox;
